import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getInvoiceConfiguration,
  postInvoiceConfiguration,
} from "data/server_apis/reportService";

const initialState = {
  data: null,
  loading: false,
  success: false,
  error: false,
  noData: false,
};

export const getInvoiceConfigurationThunk = createAsyncThunk(
  "invoice/getInvoiceThunk",
  async (_, { rejectWithValue }) => {
    try {
      return (await getInvoiceConfiguration()).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
export const postInvoiceConfigurationThunk = createAsyncThunk(
  "invoice/postInvoiceThunk",
  async (data, { rejectWithValue }) => {
    try {
      return (await postInvoiceConfiguration(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const invoiceConfigSlice = createSlice({
  name: "invoice/config",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInvoiceConfigurationThunk.pending, (state, action) => {
        state.data = null;
        state.loading = true;
        state.success = false;
        state.error = false;
        state.errorMsg = null;
        state.noData = false;
      })
      .addCase(getInvoiceConfigurationThunk.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.success = false;
        state.error = false;
        state.noData = false;
        state.errorMsg = null;
      })
      .addCase(getInvoiceConfigurationThunk.rejected, (state, action) => {
        if (action.payload?.name === 404) {
          state.noData = true;
        }
        state.data = null;
        state.loading = false;
        state.success = false;
        state.error = false;
        state.errorMsg = null;
      });

    builder
      .addCase(postInvoiceConfigurationThunk.pending, (state, action) => {
        state.loading = true;
        state.success = false;
        state.error = false;
        state.errorMsg = null;
      })
      .addCase(postInvoiceConfigurationThunk.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = true;
        state.errorMsg = action.payload.message;
      })
      .addCase(postInvoiceConfigurationThunk.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.success = true;
        state.error = false;
      });
  },
});

export const {} = invoiceConfigSlice.actions;

export default invoiceConfigSlice.reducer;
